/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostDayPassRedemption
 */
export interface HostDayPassRedemption {
    /**
     * 
     * @type {Date}
     * @memberof HostDayPassRedemption
     */
    readonly created_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof HostDayPassRedemption
     */
    readonly expires_at: Date;
}

/**
 * Check if a given object implements the HostDayPassRedemption interface.
 */
export function instanceOfHostDayPassRedemption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "expires_at" in value;

    return isInstance;
}

export function HostDayPassRedemptionFromJSON(json: any): HostDayPassRedemption {
    return HostDayPassRedemptionFromJSONTyped(json, false);
}

export function HostDayPassRedemptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostDayPassRedemption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'created_at': (new Date(json['created_at'])),
        'expires_at': (new Date(json['expires_at'])),
    };
}

export function HostDayPassRedemptionToJSON(value?: HostDayPassRedemption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

